export default {
  test: (value) => {
    return (value + '123')
  },
  currencyMoney: (money) => {
    if (money && money != null) {
      money = String(money)
      let left = money.split('.')[0], right = money.split('.')[1]
      right = right ? (right.length >= 2) ? `.${right.substr(0, 2)}` : `.${right}0` : '.00'
      let temp = left.split('').reverse().join('').match(/\d{1,3}/g)
      return `${Number(money) < 0 ? '-' : ''}${temp.join(',').split('').reverse().join('')}${right}`
    } else if(money == 0) {
      return '0.00'
    } else {
      return ''
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/filters.js